// eslint-disable-next-line no-restricted-syntax
export enum DayOfWeek {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}

export const DEFAULT_TIME_RANGE = {
  startTime: "09:00",
  endTime: "17:00",
};

export const DEFAULT_INTERVIEW_LENGTHS = [15, 30, 45, 60, 90, 120] as const;

export const DEFAULT_MIN_BOOKING_WINDOW = 2; // 2 hours
export const BOOKING_WINDOW_RANGE = [0, 24 * 7]; // min 0 hours, max 7 days

export const DEFAULT_INTERVIEW_BOOKING_DAYS = 2; // Show next 2 days with available slots
export const INTERVIEW_BOOKING_DAYS_RANGE = [1, 7]; // min 1 day, max 7 days
